import axios from 'axios'

const API_URL = process.env.VUE_APP_API_SUPPORT_URL
const SERVICE_NAME = '/user/'
const PORTAL_NAME = 'Momsite'

class UserService {
  refreshAccessToken() {
    return axios.post(API_URL + SERVICE_NAME + PORTAL_NAME + '/refresh-token')
  }
}

export default new UserService()
